import * as TYPE from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    metadata: [],
    lastQuery: null,
};

const mutations = {
    [TYPE.SET_METADATA_LIST](state, data) {
        state.metadata = data;
    },
};

const getters = {
    getMetaList(state) {
        return state.metadata;
    },
};

const actions = {
    async storeMeta({ commit, dispatch }, metaData) {
        let route = Laroute.route('franchise.meta.store');

        startLoading(dispatch, 'save-meta');

        return await axios
            .post(route, metaData)
            .then(res => {
                endLoading(dispatch, 'save-meta');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-meta');
                throw err;
            });
    },

    getMetaByModule({ commit, dispatch }, data) {
        let route = Laroute.route('franchise.meta.list-data')
            .replace('{id}', data.id)
            .replace('{module}', data.module);

        startLoading(dispatch, 'save-meta');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'save-meta');
                commit(TYPE.SET_METADATA_LIST, res.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-meta');
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
